import React from "react";
import FirstScreen from "./FirstScreen";
import TechStack from "./TechStack";
import ProjectGrid from "./ProjectGrid";
import Contact from "./Contact";

export function HomePage() {
  return (
    <div className="container">
      <section id="section-one">
        <FirstScreen />
      </section>
      <section>
        <TechStack />
      </section>
      <section id="section-two">
        <ProjectGrid />
      </section>
      <section id="section-three">
        <Contact />
      </section>
    </div>
  );
}
